module.exports = __webpack_public_path__ + "static/media/loading.21c3c576.gif";